import { Component, lazy } from 'react';
import UsersManagment from '../pages/UsersManagment';
import Keyword from '../pages/Keyword';
import ChangePasswordBySuperAdmin from '../pages/ChangePasswordBySuperAdmin';

const Books = lazy(() => import('../pages/Books.jsx'));
const Topics = lazy(() => import('../pages/Topics.jsx'));
const BookMarks = lazy(() => import('../pages/BookMarks.jsx'));
const Highlights = lazy(() => import('../pages/Highlights.jsx'));
const Chapters = lazy(() => import('../pages/Chapters.jsx'));
const Notes = lazy(() => import('../pages/Notes.jsx'));
const Search = lazy(() => import('../pages/Search.jsx'));
const Amendments = lazy(() => import('../pages/Amendments.jsx'));
const LastActivities = lazy(() => import('../pages/LastActivities.jsx'));
const RecentLaws = lazy(() => import('../pages/RecentLaws.jsx'));
const RecentSearches = lazy(() => import('../pages/RecentSearches.jsx'));
const BachelorsTthesisReport = lazy(
  () => import('../pages/BachelorsTthesisReport.jsx'),
);
const SupportAndTicketManagement = lazy(
  () => import('../pages/SupportAndTicketManagement.jsx'),
);
const UserPerformanceReport = lazy(
  () => import('../pages/UserPerformanceReport.jsx'),
);
const SubjectCodeChanges = lazy(
  () => import('../pages/SubjectCodeChanges.jsx'),
);
const TabulationChanges = lazy(() => import('../pages/TabulationChanges.jsx'));

const Roles = lazy(() => import('../pages/Roles'));
const FormElements = lazy(() => import('../pages/Form/FormElements'));
const FormLayout = lazy(() => import('../pages/Form/FormLayout'));
const Profile = lazy(() => import('../pages/Profile'));
const Settings = lazy(() => import('../pages/Settings'));

const coreRoutes = [
  // {
  //   path: '/home',
  //   title: 'Home',
  //   component: Home,
  // },
  {
    path: '/TabulationChanges',
    title: 'TabulationChanges',
    component: TabulationChanges,
  },
  {
    path: '/SubjectCodeChanges',
    title: 'SubjectCodeChanges',
    component: SubjectCodeChanges,
  },
  {
    path: '/UserPerformanceReport',
    title: 'UserPerformanceReport',
    component: UserPerformanceReport,
  },
  {
    path: '/support-and-ticket-management/:id',
    title: 'SupportAndTicketManagement',
    component: SupportAndTicketManagement,
  },
  {
    path: '/bachelors-thesis-report',
    title: 'BachelorsThesisReport',
    component: BachelorsTthesisReport,
  },
  {
    path: '/recent-searches',
    title: 'RecentSearches',
    component: RecentSearches,
  },
  {
    path: '/recent-laws',
    title: 'RecentLaws',
    component: RecentLaws,
  },
  {
    path: '/lastActivities',
    title: 'LastActivities',
    component: LastActivities,
  },
  {
    path: '/amendments',
    title: 'Amendments',
    component: Amendments,
  },
  {
    path: '/search',
    title: 'Search',
    component: Search,
  },
  {
    path: '/notes',
    title: 'Notes',
    component: Notes,
  },
  {
    path: '/chapters',
    title: 'Chapters',
    component: Chapters,
  },
  {
    path: '/highlights',
    title: 'Highlights',
    component: Highlights,
  },
  {
    path: '/topics',
    title: 'Topics',
    component: Topics,
  },
  {
    path: '/books',
    title: 'Books',
    component: Books,
  },
  {
    path: '/bookmarks',
    title: 'BookMarks',
    component: BookMarks,
  },
  {
    path: '/profile',
    title: 'Profile',
    component: Profile,
  },
  {
    path: '/forms/form-elements',
    title: 'Forms Elements',
    component: FormElements,
  },
  {
    path: '/forms/form-layout',
    title: 'Form Layouts',
    component: FormLayout,
  },

  {
    path: '/settings',
    title: 'Settings',
    component: Settings,
  },

  {
    path: '/usersmanagement',
    title: 'usersmanagement',
    component: UsersManagment,
  },

  {
    path: '/keyword',
    title: 'keyword',
    component: Keyword,
  },

  {
    path: '/roles',
    title: 'Roles',
    component: Roles,
  },
  {
    path: '/changepasswordbysuperadmin',
    title: 'changepassword',
    component: ChangePasswordBySuperAdmin,
  },
];

const routes = [...coreRoutes];
export default routes;
